import React from "react";
import axios from "axios";
import Spinner from "../../components/Spinner";
import { Modal } from "../../components/Modal";
import {primaryLabelName, secondaryLabelName, uniqueIdentifier1Name} from "../../utils/helper"

const API = localStorage.getItem("assethost");

export default class UpdateBack extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      msg: "",
      toastColor: "",
      assetId: "",
      assetType: "",
      assetBrand: "",
      assetModel: "",
      assetUniqueIdentier: "",
      showConfirm: false,
    };
    this.handleDeregister = this.handleDeregister.bind(this);
  }

  componentDidMount() {
    const urlParams = new URLSearchParams(window.location.search);
    let assetId = urlParams.get("assetId");
    if (!assetId) {
      assetId = this.props.assetId;
    }
    const assetType = this.props.assetType;
    const assetBrand = this.props.assetBrand;
    const assetModel = this.props.assetModel;
    const assetUniqueIdentier = this.props.assetUniqueIdentier;

    if (assetId) {
      this.setState({
        assetId,
        assetType,
        assetBrand,
        assetModel,
        assetUniqueIdentier,
      });
    } else {
      this.setState({
        msg: "No asset ID provided",
        toastColor: "danger",
      });
    }
  }

  handleDeregister() {
    const token = sessionStorage.getItem("token");
    if (!token) {
      this.setState({
        msg: "No User Token",
        toastColor: "danger",
      });
      sessionStorage.clear();
      window.location.href = `/?redirectUrl=${
        window.location.pathname + window.location.search
      }`;
      return;
    }

    this.setState({ loading: true, msg: "", toastColor: "" });

    axios
      .post(
        API + `/asset/updateback/${this.state.assetId}`,
        {},
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      )
      .then((response) => {
        if (response.data.success) {
          this.setState({
            msg: response.data.message || "Asset Updated Status successfully!",
            toastColor: "success",
            loading: false,
          });
          setTimeout(() => {
            this.props.closeAction();
            if (this.props.onSuccess) {
              this.props.onSuccess();
            }
          }, 2000);
        } else {
          this.setState({
            msg: response.data.message || "Asset Updated Status failed",
            toastColor: "danger",
            loading: false,
          });
        }
      })
      .catch((error) => {
        if (Number(error.status) === 403) {
          sessionStorage.clear();
          window.location.href = `/?redirectUrl=${
            window.location.pathname + window.location.search
          }`;
        }
        this.setState({
          msg:
            error?.response?.data?.message ||
            "Deregistration failed. Please try again.",
          toastColor: "danger",
          loading: false,
        });
      });
  }

  render() {
    const s = this.state;
    let divMsg = null;
    if (s.msg) {
      divMsg = (
        <div
          className={
            s.toastColor === "success"
              ? "alert alert-success mx-7"
              : "alert alert-danger mx-7"
          }
        >
          {s.msg}
        </div>
      );
    }

    if (s.loading) {
      return (
        <Modal title="Deregister Asset" footerContent={<></>}>
          <div className="w-100 h-10 overflow-hidden d-flex justify-content-center align-items-center">
            <Spinner className="" />
          </div>
        </Modal>
      );
    }

    return (
      <Modal
        title="Asset Update Status"
        closeAction={() => window.history.back()}
        footerContent={
          <>
            <button
              type="button"
              className="btn btn-primary"
              onClick={this.handleDeregister}
            >
              Update Status
            </button>
            <button
              type="button"
              className="btn btn-primary"
              onClick={this.props.closeAction}
            >
              Close
            </button>
          </>
        }
      >
        <div className="h-100 w-100 d-flex flex-column">
          {divMsg}
          <div className="row">
            <div className="col">
              <b>{primaryLabelName(s.assetType)}: </b>
              <span>{s.assetBrand}</span>
            </div>
            <div className="col">
              <b>{secondaryLabelName(s.assetType)}: </b>
              <span>{s.assetModel}</span>
            </div>
          </div>
          <div className="row">
            <div className="col">
              <b>{uniqueIdentifier1Name(s.assetType)}: </b>
              <span>{s.assetUniqueIdentier}</span>
            </div>
          </div>
        </div>
      </Modal>
    );
  }
}
